import { Injectable } from '@angular/core';
import { IFirebaseAddress } from '@ztarmobile/zwp-service-backend';
import { ManagePaymentModalContextComponent, PaymentModalContext } from '../modals/manage-payment-modal-context/manage-payment-modal-context.component';
import { ConfirmMessageModalComponent } from '../modals/confirm-message-modal/confirm-message-modal.component';
import { ConfirmPasswordModalComponent } from '../modals/confirm-password-modal/confirm-password-modal.component';
import { InformationMessageModalComponent } from '../modals/information-message-modal/information-message-modal.component';
import { AddActivatedNumberModalComponent } from '../modals/add-activated-number-modal/add-activated-number-modal.component';
import { InputModalComponent } from '../modals/input-modal/input-modal.component';
import { RoutingModalComponent } from '../modals/routing-modal/routing-modal.component';
import { EditCcModalComponent } from '../modals/edit-cc-modal/edit-cc-modal.component';
import { SelectCCModalComponent } from '../modals/select-payment-modal/select-payment-modal.component';
import { ShippingAddressModalComponent } from '../modals/shipping-address-modal/shipping-address-modal.component';
import { SimReplacementModalComponent } from '../modals/sim-replacement-modal/sim-replacement-modal.component';
import { FiveGModalComponent } from 'src/modals/fiveg-modal/fiveg-modal.component';
import { PhoneNotImpactedModalComponent } from 'src/modals/phone-not-impacted-modal/phone-not-impacted-modal.component';
import { DialogPosition, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { AlertSecurityModalComponent } from 'src/modals/alert-security-modal/alert-security-modal.component';
import { IosDataSetupModalComponent } from 'src/modals/ios-data-setup-modal/ios-data-setup-modal.component';
import { CompatibilitySkipModalComponent } from 'src/modals/skip-device-modal/skip-device-modal.component';
import { eSimReplacementModalComponent } from 'src/modals/esim-replacement-modal/esim-replacement-modal.component';
import { IShipmentTracking, IUserProfile } from '@ztarmobile/zwp-service-backend-v2';
import { TrackingModalComponent } from 'src/modals/tracking-details-modal/tracking-details-modal.component';
import { successModalComponent } from 'src/modals/success-modal/success-modal.component';
import { InstractionsFiveGIos17ModalComponent } from 'src/modals/instractions-five-g-ios17-modal/instractions-five-g-ios17-modal.component';
import { GoogleLoginComponent } from 'src/modals/google-login/google-login.component';
import { RecaptchaVerificationComponent } from 'src/modals/recaptcha-verification/recaptcha-verification.component';
import { IldCountriesComponent } from 'src/modals/ild-countries/ild-countries.component';
import { WifiCallingModalComponent } from 'src/modals/wifi-calling-modal/wifi-calling-modal.component';
import { emailVerificationModalComponent } from 'src/modals/email-verification-needed-modal/email-verification-needed-modal.component';
import { AccountPaymentProfile } from '@ztarmobile/zwp-service-backend-v2';
import { IntCallingListModalComponent } from 'src/modals/int-calling-list-modal/int-calling-list-modal.component';
import { FailureModalComponent } from 'src/modals/failure-modal/failure-modal.component';
import { ChangePinData, ChangePinModalComponent } from 'src/modals/change-pin-modal/change-pin-modal.component';
import { ChangePasswordModalComponent, ChangePasswordModalData } from 'src/modals/change-password-modal/change-password-modal.component';
import { ChangeNameModalComponent, ChangeNameModalData } from 'src/modals/change-name-modal/change-name-modal.component';
import { ChangeEmailModalComponent, ChangeEmailModalData } from 'src/modals/change-email-modal/change-email-modal.component';
import { AddPaymentCardModalComponent, AddPaymentModalData } from 'src/modals/add-payment-card-modal/add-payment-card-modal.component';
import { AddAddressModalComponent, AddressModalDataType } from 'src/modals/add-address-modal/add-address-modal.component';
import { PayGoListModalComponent } from 'src/modals/pay-go-list-modal/pay-go-list-modal.component';
import { ErrorModalComponent } from 'src/modals/error-modal/error-modal.component';

export interface ModalSetting {
  title?: string;
  subMessage?: string;
  okText?: string;
  cancelText?: string;
  customClass?: string;
  enableHTML?: boolean;
  hideCloseIcon?:boolean;
  lastNote?: string;
  hideCancelBtn?:boolean;
  isCancelBtnTertiary?: boolean
}

export interface IntCallingListData {
  title?: string,
  subtitle?: string,
  customClass?: string
}

export interface IModalHelper {
  showManagePaymentContextModal(data: PaymentModalContext): MatDialogRef<any>;
  showConfirmMessageModal(title: string, message: string, okText?: string, cancelText?: string, customClass?: string,subMessage?: string, enableHTML?:boolean): MatDialogRef<any>;
  showConfirmMessage(message: string, settings?: ModalSetting): MatDialogRef<any>;
  showConfirmPasswordModal(title: string, message: string, customClass?: string): MatDialogRef<any>;
  showInformationMessageModal(title: string, message: string, btnText?: string, btnUrl?: string, hasCloseLink?: boolean, customClass?: string, customHTML?: string, cancelBtn?: boolean, cancelText?: string, noteText?: string): MatDialogRef<any>;
  showAddActivatedNumberModal(customClass?: string, title?: string, label?: string): MatDialogRef<any>;
  showInputModal(title: string, message: string, okText?: string, okBtnClass?: string, customClass?: string, isCancelable?: boolean, cancelText?: string, cancelBtnClass?: string, labelText?: string): MatDialogRef<any>;
  showRoutingModal(title: string, message: string, hasCloseLink?: boolean, yesButtonText?: string, noButtonText?: string, skipButtonText?: string, yesButtonLink?: string, noButtonLink?: string, skipButtonLink?: string, customClass?: string): MatDialogRef<any>;
  showEditCreditCardModal(paymentMethod: AccountPaymentProfile, title: string, note: string, noteLinkText: string, customClass?: string): MatDialogRef<any>;
  showSelectCreditCardModal(paymentList: Array<AccountPaymentProfile>, title: string, mdn: string, buttonText: string, customClass?: string, profileKey?: string): MatDialogRef<any>;
  showShippingAddressModal(title: string, shippingAddress?: IFirebaseAddress, customClass?: string): MatDialogRef<any>;
  showSIMModal(title: string, message: string, okText?: string, okBtnClass?: string, customClass?: string, network?: string, labelText?: string, showRecaptcha?: boolean): MatDialogRef<any>;
  showNotImpactedModal(title: string, message: string, customClass?: string): MatDialogRef<any>;
  showFiveGModal(title: string, customHTML: string, linkText: string, linkRoute: any, customClass?: string, hasCloseLink?: boolean): MatDialogRef<any>;
  showAlertSecurityModal(title: string, primaryBtn?: string, secondaryBtn?: string, timer?: boolean, customClass?: string, customHTML?: string): MatDialogRef<any>;
  showSkipModal(title: string, hasCloseLink?: boolean, customClass?: string, notBeforeSkipping?: boolean): MatDialogRef<any>;
}

@Injectable({
  providedIn: 'root'
})

export class ModalHelper implements IModalHelper {

  constructor(private dialog: MatDialog) { }

  public showManagePaymentContextModal(data: PaymentModalContext): MatDialogRef<any> {
    return this.dialog.open(ManagePaymentModalContextComponent, {
      data,
      disableClose: true,
    });
  }

  public showConfirmMessageModal(title: string, message: string, okText?: string, cancelText?: string, customClass?: string, subMessage?: string, enableHTML?:boolean, lastNote?:string, hideCancelBtn?:boolean): MatDialogRef<any> {
    return this.showConfirmMessage(message, { title, subMessage, okText, cancelText, customClass, enableHTML: enableHTML , lastNote, hideCancelBtn});
  }

  public showConfirmMessage(message: string, settings?: ModalSetting): MatDialogRef<any> {
    return this.dialog.open(ConfirmMessageModalComponent, {
      data: { message, settings }
    });
  }

  public showConfirmPasswordModal(title: string, message: string, customClass?: string): MatDialogRef<any> {
    return this.dialog.open(ConfirmPasswordModalComponent, {
      data: { title, message, customClass }
    });
  }

  public showFiveGModal(title: string, customHTML: string, linkText: string, linkRoute: any, customClass?: string, hasCloseLink?: boolean): MatDialogRef<any> {
    return this.dialog.open(FiveGModalComponent, {
      data: { title, customHTML, linkText, linkRoute, customClass, hasCloseLink }
    });
  }

  public showInformationMessageModal(title: string, message: string, btnText?: string, btnUrl?: string, hasCloseLink?: boolean, customClass?: string, customHTML?: string, cancelBtn?: boolean, cancelText?: string, noteText?: string, specificCancelReturn?: string, position?: DialogPosition): MatDialogRef<any> {
    return this.dialog.open(InformationMessageModalComponent, {
      position,
      disableClose: true,
      data: { title, message, btnText, btnUrl, hasCloseLink, customClass, customHTML, cancelBtn, cancelText, noteText, specificCancelReturn }
    });
  }

  public showAddActivatedNumberModal(customClass?: string, title?: string, label?: string): MatDialogRef<any> {
    return this.dialog.open(AddActivatedNumberModalComponent, {
      data: { customClass, title, label }, autoFocus: false
    });
  }

  public showInputModal(title: string, message: string, okText?: string, okBtnClass?: string, customClass?: string,
    isCancelable?: boolean, cancelText?: string, cancelBtnClass?: string, labelText?: string): MatDialogRef<any> {
    return this.dialog.open(InputModalComponent, {
      data: { title, message, okText, okBtnClass, customClass, isCancelable, cancelText, cancelBtnClass, labelText }
    });
  }

  public showRoutingModal(title: string, message: string, hasCloseLink?: boolean, yesButtonText?: string, noButtonText?: string, skipButtonText?: string, yesButtonLink?: string, noButtonLink?: string, skipButtonLink?: string, customClass?: string): MatDialogRef<any> {
    return this.dialog.open(RoutingModalComponent, {
      data: { title, message, hasCloseLink, yesButtonText, noButtonText, skipButtonText, yesButtonLink, noButtonLink, skipButtonLink, customClass }
    });
  }

  public showEditCreditCardModal(paymentMethod: AccountPaymentProfile, title: string, customClass?: string): MatDialogRef<any> {
    return this.dialog.open(EditCcModalComponent, {
      data: { paymentMethod, title, customClass }
    });
  }

  public showSelectCreditCardModal(paymentList: Array<AccountPaymentProfile>, title: string, mdn: string, buttonText: string, customClass?: string, profileKey?: string): MatDialogRef<any> {
    return this.dialog.open(SelectCCModalComponent, {
      data: { paymentList, title, mdn, buttonText, customClass, profileKey }
    });
  }

  public showShippingAddressModal(title: string, shippingAddress?: IFirebaseAddress, customClass?: string): MatDialogRef<any> {
    return this.dialog.open(ShippingAddressModalComponent, {
      data: { title, shippingAddress, customClass }
    });
  }

  public ShowIosDataSetupModalComponent(network: string, isIos17 = false): MatDialogRef<any> {
    return this.dialog.open(IosDataSetupModalComponent, {
      data: { network, isIos17 }
    });
  }

  public successModal(message: string, buttonText?: string, customClass?: string, title?: string, customHTML?: string, customImage?:string, hideClose?: boolean): MatDialogRef<any> {
    return this.dialog.open(successModalComponent, {
      data: {
        message, buttonText, customClass, title, customHTML, customImage, hideClose
      }
    });
  }

  showNotImpactedModal(title: string, message: string, customClass?: string): MatDialogRef<any> {
    return this.dialog.open(PhoneNotImpactedModalComponent, {
      data: { title, message }
    });
  }

  public showSIMModal(title: string, message: string, okText?: string, okBtnClass?: string, customClass?: string,
    network?: string, labelText?: string, showRecaptcha?: boolean): MatDialogRef<any> {
    return this.dialog.open(SimReplacementModalComponent, {
      data: { title, message, okText, okBtnClass, customClass, network, labelText, showRecaptcha }
    });
  }
  showeSIMModal(iccid: string, mdn: string, title: string, customClass?: string): MatDialogRef<any> {
    return this.dialog.open(eSimReplacementModalComponent, {
      data: {
        iccid, mdn, title, customClass
      }
    });
  }
  showWifiCallingModal(title: string, termsRoute: string, customClass?: string, wifiAddress?: IFirebaseAddress): MatDialogRef<any> {
    return this.dialog.open(WifiCallingModalComponent, {
      data: { title, termsRoute, customClass, wifiAddress }
    });
  }
  public showAlertSecurityModal(title: string, primaryBtn?: string, secondaryBtn?: string, timer?: boolean, customClass?: string, customHTML?: string): MatDialogRef<any> {
    return this.dialog.open(AlertSecurityModalComponent, {
      disableClose: true,
      data: {
        title, primaryBtn, secondaryBtn, timer, customClass, customHTML
      }
    });
  }
  public showSkipModal(title: string, hasCloseLink?: boolean, customClass?: string, notBeforeSkipping?: boolean): MatDialogRef<any> {
    return this.dialog.open(CompatibilitySkipModalComponent, {
      data: {
        title, hasCloseLink, customClass, notBeforeSkipping
      }
    });
  }

  public showTrackingModal(title: string, trackingDetails: IShipmentTracking, trackingNumber: string, customClass?: string): MatDialogRef<any> {
    return this.dialog.open(TrackingModalComponent, {
      data: {
        title, trackingDetails, trackingNumber, customClass
      }
    });
  }

  showIphone5GIos17InstructionsModal() {
    return this.dialog.open(InstractionsFiveGIos17ModalComponent, {
      width: '700px',
      maxWidth: '97%'
    });
  }

  public showGoogleLoginsModal() {
    return this.dialog.open(GoogleLoginComponent, {
      width: '500px',
      maxWidth: '97%',
      height: '200px'
    });
  }
  
  public showRecaptchaVerificationModal() {
    return this.dialog.open(RecaptchaVerificationComponent);
  }
  public showILDCountries() {
    return this.dialog.open(IldCountriesComponent);
  }
  showEmailVerificationNeededModal(email) : MatDialogRef<any> {
    return this.dialog.open(emailVerificationModalComponent, {
      disableClose: true,
      data: {
        email
      }
    });
  }

  public showChangePinModal(data: ChangePinData) {
    return this.dialog.open(ChangePinModalComponent, { data });
  }

  public showChangePasswordModal(data: ChangePasswordModalData) {
    return this.dialog.open(ChangePasswordModalComponent, { data });
  }

  public showChangeNameModal(data: ChangeNameModalData) {
    return this.dialog.open(ChangeNameModalComponent, { data });
  }

  public showChangeEmailModal(data: ChangeEmailModalData) {
    return this.dialog.open(ChangeEmailModalComponent, { data });
  }

  public showAddPaymentCardModal(data: AddPaymentModalData) {
    return this.dialog.open(AddPaymentCardModalComponent, { data });
  }

  public showAddAddressModal(data: AddressModalDataType) {
    return this.dialog.open(AddAddressModalComponent, { data });
  }

  public showIntCallingListModal(data: IntCallingListData) {
    return this.dialog.open(IntCallingListModalComponent, { data });
  }

  public failureModal(message: string, buttonText?: string, customClass?: string, title?: string, customHTML?: string, customImage?: string): MatDialogRef<any> {
    return this.dialog.open(FailureModalComponent, {
      data: {
        message, buttonText, customClass, title, customHTML, customImage
      }
    });
  }
  public showPayGoCountriesModal(data): MatDialogRef<any> {
    return this.dialog.open(PayGoListModalComponent, {
      data,
    });
  }
  public showErrorModal(title: string, message: string, hasCloseLink: boolean, displayErrorIcon:boolean, customHTML?: string, customClass?: string, btnText?: string, secondaryText?:string): MatDialogRef<any> {
    return this.dialog.open(ErrorModalComponent, {
      disableClose: true,
      data: {
        title, message, hasCloseLink, displayErrorIcon, customHTML, customClass, btnText, secondaryText
      }
    });
  }
}